import { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography, Card } from '@mui/material';
import { Fade } from '@mui/material';

const analysisSteps = [
  'Checking local estate taxes',
  'Evaluating inheritance tax thresholds',
  'Assessing probate difficulty',
  'Reviewing family scenarios',
  'Looking at net worth and assets',
];

const EstatePlanLoader = () => {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStepIndex((prev) => (prev + 1) % analysisSteps.length);
    }, 1500); // rotate every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
    <Card
      variant="outlined"
      sx={{
        borderRadius: 1,
        border: 'none',
        p: {
          xs: 1, // padding on extra small screens
          sm: 2, // padding on small screens
          md: 3, // padding on medium screens
          lg: 3, // padding on large screens
          xl: 3, // padding on extra large screens
        },
        px: {
          xs: 1, // padding on extra small screens
          sm: 1, // padding on small screens
          md: 4, // padding on medium screens
          lg: 4, // padding on large screens
          xl: 4, // padding on extra large screens
        },
        pb: 4,
      }}
    >
        <Box sx={{ textAlign:'center', width:'100%'}}>
        <CircularProgress />
        <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>
          Building your personal plan.
        </Typography>
        <Fade in key={stepIndex}>
          <Typography variant="body1" color="text.secondary">
            {analysisSteps[stepIndex]}
          </Typography>
        </Fade>
        <style>{`
        .MuiCircularProgress-circle {
          stroke-linecap: round;
        }
      `}</style>
        </Box>
      </Card>
      </div>
  );
};

export default EstatePlanLoader;
